export const hasPermission = (user, permission) => {
    const hasPermission = user.permissions.includes(permission);
    return hasPermission;
};

export const canManageEvent = (user, event_role) => {
    const canManageAllEvents = hasPermission(user, 'can_manage_all_events');
    return canManageAllEvents || event_role === 'delegate';
};

export const hasPermissionToPayOrListDues = (user) => {
    const is_student = user.roles.includes('student') && !user.parent,
        is_parent = Boolean(user.children?.length);

    const is_former_student = user.roles.includes('former_student');
    if (is_student || is_parent || is_former_student) {
        return true;
    }
    return false;
};
